import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import Services from "./Service/ServiceStore";
import Utility from "./Utility/UtilityStore";
import Branch from "./Branch/BranchStore";
import Membership from "./Membership/MembershipStore";
import MembershipRate from "./Membership/MembershipRateStore";
import MembershipBenefit from "./Membership/MembershipBenefitStore";
import MiniType from "./Branch/TCDCMiniTypeStore";
import ServicesArea from "./Service/ServiceAreaStore";
import VenueHire from "./Service/VenueHireStore";
import VenueHireDetails from "./Service/VenueHireDetailsStore";
import GroupVisit from "./Service/GroupVisitStore";
import TravelInfo from "./Service/TravelInfoStore";
import Restaurant from "./Service/RestaurantStore";
import TCDCMini from "./Branch/TCDCMiniStore";
import About from "./About/AboutStore";
import Network from "./About/NetworkStore";
import Login from "./Utility/LoginStore";
import Menu from "./Menu/MenuStore";
import SubMenu from "./Menu/SubMenuStore";
import Floor from "./Service/FloorStore";
import Members from "./Membership/MembersStore";
import Location from "./About/LocationStore";
import ResourceCenter from "./ResourceCenter/ResourceCenterStore";
import OnlineExhibition from "./ResourceCenter/OnlineExhibitionStore";
import News from "./About/NewsStore";
import Partner from "./About/PartnerStore";
import SponserProgram from "./About/SponserProgramStore";
import Contact from "./About/ContactStore";
import DesignWorldCalendar from "./DesignWorldCalendar/DesignWorldCalendarStore";
import Faq from "./Faq/FaqStore";
import FaqCategory from "./Faq/FaqCategoryStore";
import Banner from "./Banner/BannerStore";
import LandingPage from "./LandingPage/LandingPageStore";
import Auth from './Utility/LoginStore'
import User from "./UserManagement/UserStore";
import UserRole from "./UserManagement/UserRoleStore";
import Permission from "./UserManagement/PermissionStore";
import SupportContact from './CustomerSupport/ContactStore'
import SupportVenueHire from './CustomerSupport/VenueHireStore'
import SupportGroupVisit from './CustomerSupport/GroupVisitStore'
import FreePage from "./FreePage/FreePageStore";
import MainPage from "./MainPage/MainPageStore";
import OurService from "./OurService/OurServiceStore";
Vue.use(Vuex);
const modules = {
  Services,
  Utility,
  Branch,
  Membership,
  MembershipRate,
  MembershipBenefit,
  MiniType,
  ServicesArea,
  VenueHire,
  VenueHireDetails,
  GroupVisit,
  TravelInfo,
  Restaurant,
  TCDCMini,
  About,
  Network,
  Login,
  Menu,
  SubMenu,
  Floor,
  Members,
  Location,
  ResourceCenter,
  OnlineExhibition,
  News,
  Partner,
  SponserProgram,
  Contact,
  DesignWorldCalendar,
  Faq,
  FaqCategory,
  Banner,
  LandingPage,
  Auth,
  User,
  UserRole,
  Permission,
  SupportContact,
  SupportVenueHire,
  SupportGroupVisit,
  FreePage,
  MainPage,
  OurService,
};

export default new Vuex.Store({
  modules,
  plugins: [createPersistedState()]
});
